import createReactComponent from '../createReactComponent';
export default createReactComponent('move-diagonal', 'MoveDiagonal', [["path",{"d":"M13 5h6m0 0v6m0-6L5 19m6 0H5m0 0v-6","key":"svg-0"}]]);